// @flow

const test = () => {
  if (typeof window === 'undefined') {
    return null;
  }
  const ua = window.navigator.userAgent;

  // https://stackoverflow.com/a/29696509 + comments
  return (
    /iP(ad|od|hone)/i.test(ua) &&
    /WebKit/i.test(ua) &&
    !/(Chrome|CriOS|OPiOS|EdgiOS)/.test(ua)
  );
};

export const isIOS: ?boolean = test();
